<template>
  <div>
    <section class="hero">
      <div class="hero-body">
        <router-link :to="`/${$router.currentRoute.params.slug}`" class="container">
          <figure class="image logo">
            <img :src="logo" alt="Logo" v-if="logo">
          </figure>
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      logo(state) {
        return state[this.$route.params.slug].logo
      },
    }),
  },
  mounted() {
    const Confettiful = function(el) {
      this.el = el;
      this.containerEl = null;
      
      this.confettiFrequency = 3;
      this.confettiColors = ['#fce18a', '#ff726d', '#b48def', '#f4306d'];
      
      this._setupElements();
      this._renderConfetti();
    };

    Confettiful.prototype._setupElements = function() {
      const containerEl = document.createElement('div');
      containerEl.classList.add('confetti-container');
      this.el.appendChild(containerEl);
      this.containerEl = containerEl;
    };

    Confettiful.prototype._renderConfetti = function() {
      this.confettiInterval = setInterval(() => {
        const confettiEl = document.createElement('div');
        const confettiSize = (Math.floor(Math.random() * 3) + 7) + 'px';
        const confettiBackground = this.confettiColors[Math.floor(Math.random() * this.confettiColors.length)];
        const confettiLeft = (Math.floor(Math.random() * this.el.offsetWidth)) + 'px';
        const confettiAnimation = 'slow';
        
        confettiEl.classList.add('confetti', 'confetti--animation-' + confettiAnimation);
        confettiEl.style.left = confettiLeft;
        confettiEl.style.width = confettiSize;
        confettiEl.style.height = confettiSize;
        confettiEl.style.backgroundColor = confettiBackground;

        this.containerEl.appendChild(confettiEl);
      }, 10);
        
      
      setTimeout(() => {
        clearInterval(this.confettiInterval);
        setTimeout(() => {
          const node = document.querySelector('.confetti-container');
          node.parentNode.removeChild(node);
        }, 1500);
      }, 2500);
    };

    new Confettiful(document.querySelector('.hero'));
  },
};
</script>

<style lang="scss">
@keyframes confetti-slow {
  0% { transform: translate3d(0, 0, 0) rotateX(0) rotateY(0); }
  
  100% { transform: translate3d(25px, 105vh, 0) rotateX(360deg) rotateY(180deg); }
}

@keyframes confetti-medium {
  0% { transform: translate3d(0, 0, 0) rotateX(0) rotateY(0); }
  
  100% { transform: translate3d(100px, 105vh, 0) rotateX(100deg) rotateY(360deg); }
}

@keyframes confetti-fast {
  0% { transform: translate3d(0, 0, 0) rotateX(0) rotateY(0); }
  
  100% { transform: translate3d(-50px, 105vh, 0) rotateX(10deg) rotateY(250deg); }
}

.confetti-container {
  perspective: 700px;
  position: absolute;
  overflow: hidden;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.confetti {
  position: absolute;
  z-index: 1;
  top: -10px;
  border-radius: 0%;

  &--animation-slow {
    animation: confetti-slow 1.75s linear 1 forwards;
  }
}
</style>
